import { type FC } from "react";
import { Presentation } from "./Presentation";
import { useBonusAvailableInputs } from "./useBonusAvailableInputs";
import { type ComponentHash } from "./type";

type Props = {
  componentHash: ComponentHash;
};

export const BonusAvailableInputs: FC<Props> = ({ componentHash }) => {
  const bonusAvailableInputsData = useBonusAvailableInputs(componentHash);

  if (!bonusAvailableInputsData) {
    return null;
  }

  const {
    text,
    parentCheckboxId,
    formNames,
    inputValues,
    errors,
    bonusCheckboxChecked,
    handleChangeBonusCheckbox,
    handleInputChange,
    bonusPaymentYearSelectOptions,
    bonusPaymentCountSelectOptions,
    value,
  } = bonusAvailableInputsData;

  return (
    <Presentation
      text={text}
      parentCheckboxId={parentCheckboxId}
      errors={errors}
      bonusCheckboxChecked={bonusCheckboxChecked}
      handleChangeBonusCheckbox={handleChangeBonusCheckbox}
      handleInputChange={handleInputChange}
      formNames={formNames}
      inputValues={inputValues}
      bonusPaymentYearSelectOptions={bonusPaymentYearSelectOptions}
      bonusPaymentCountSelectOptions={bonusPaymentCountSelectOptions}
      value={value}
    />
  );
};
